import React from 'react'
import styles from "./schoolRitualBlockThree.module.css"
import LazySection from '../LazySection'

function SchoolRitualBlockThree({ theMicrocosmicRef, aligningTheElementsRef, invocationOfDivineInfiniteBeing, invocationOfTheRef, finalPronouncementRef, hermesApolloRef }) {
    return (
        <>
            <div className={styles.school_ritual_psd3_mainWrp}>

                {/* ---------------------------block1------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block1_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h2 ref={theMicrocosmicRef}>The Microcosmic Invocation</h2>
                                        <h3>The Seed and the Egg</h3>
                                        <h5>Identification with the Body of Light and the Personal Ochema</h5>
                                        <p>
                                            The theurgist now identified with the anthropomorphic form of Kali-Krishna becomes the child within the egg.  The last three resonate Divine Names are the invocation of the Microcosm within the now invoked Macrocosmic order. This begins through the calling of the Astral Plane itself, the Anima Mundi, Hecate, the fertile power of the higher aspects of Kali <span>(see Central Doctrine)</span>. Within the Anima Mundi is the Soul of the World, the Causal Diamond of the earth that has the entire past, present and future of the entire earth within its branch history world line. It is within the Anima Mundi that divinatory and revelatory imagery and <span>“data”</span> is accessed by the theurgist. In order for the theurgist to access this realm they must now identify directly with the objective body of light and at once the infinite eternal divine double, the personal Daemon that lies on the perimeter of the spherical self boundary.  This opens the theurgist's awareness of the seed <span>(the body of light)</span> and the egg <span>(the personal ochēma)</span>.


                                        </p>
                                        <h3>The Microcosmic Invocation</h3>


                                        <p>
                                            Now that we have set ourselves within the visionary landscape of divine revelation through
                                            identification as the Macrocosm, we become the reflected seed, the egg within its presence, set to emerge into the realm of immortal direct experience.  Up to this point it was very important to build one element upon the next in order to develop the Macrocosmic vision, now moving onto the
                                            Microcosmic the initial ritual work is left to the energies it invoked as background and you are going to enter into the Seed and the Egg. Once you have performed the Grand Invocation many successive times the Macrocosmic elements will naturally remain vibrant, as the seed and the egg are to speak planted within the ecstasy of the highest Kali-Krishna.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block1_mainWrp_bg.webp"
                                        alt='Image'
                                    />

                                    <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block1_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block2------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block2_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>Hecate</h3>
                                        <h5>Drawing to awareness the Cosmic Soul, the Astral Plane, the Anima Mundi</h5>
                                        <p>
                                            We summon the Astral plane, the Cosmic Soul, the boundless ocean of intuition that surrounds and permeates us—Hecate, the Anima Mundi. While known in many Western traditions as the Holy Spirit, one of the three major aspects of the Godhead, for us, she is the very wellspring of intuition, the unseen made visible, the yet-to-be-known brought into being. Hecate, liminal guardian, stands at the
                                            crossroads of existence, sovereign over thresholds, passages, and all transformations. She is the
                                            esoteric efflorescence of Kali, her transcendent form—not superior, but the radiant luminosity within Kali's complete and awe-inspiring totality. She is the intermediary manifold, the Cosmic Soul, the Anima Mundi, Hecate. The feminine presence that embodies the eternal archetypes and forms within the great feminine void.  She opens the gates to the gods, goddesses and the daemonic forces, both binding them into form and acting as the medium through which they manifest.


                                        </p>
                                        <p>
                                            Kali, in her invoked presence, utterly annihilates and purifies any and all of the nefarious demonic, that which obstructs and defiles. This sanctified space, cleansed by Kali's power, allows the theurgist, through the potent invocation of Hecate, to give form to the vast and often overwhelming forces of vast agency: the daemons, the planetary intelligences, and all other forms of direct, unmediated experience. Hecate, Queen of the Daemonic, is the radiant emanation of Kali, she who births all ritual experience within her cosmic womb. She is the transitional gateway, delineating the very shape and substance of direct experience, guiding the ritual journey from the murky depths of unconsciousness into the blazing light of conscious awareness, just as the full moon emerges in its cyclical majesty from the veiled darkness of the new moon.</p>


                                        <p>

                                            Hecate, the psychopomp, leads souls through the labyrinthine mysteries, illuminating the hidden
                                            pathways that wind toward wisdom and revelation. Her torches, blazing with celestial fire, pierce the veil of the unseen, revealing the subtle, often imperceptible currents of fate and destiny. She is the
                                            mistress of magic, her immense power intricately woven into the very fabric of the Cosmos, a force that both sustains and transcends all that is.  In the transformative power of Hecate the Divine
                                            Intelligences take form

                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block2_mainWrp_bg.webp"
                                        alt='Image'

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block3------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block3_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <p>
                                            From our Central Doctrine: <span>“The lunar phases play a profound symbolic role, resonating deeply within the human psyche and the very structure of the universe. For our school Hecate, the goddess of the new moon, stands as the guardian of the unconscious mind, the gateway to the collective
                                                unconscious. Her domain is the darkened sky, where the light of the stars and planets — whose vast agency reflects the eternal archetypes and forms—shines through the veil of night. It is in this
                                                darkness that the seeds of creation are planted, and the hidden potentials of the Cosmos and the human soul are nurtured.</span>



                                        </p>
                                        <p>
                                            <span>
                                                Hecate's association with the new moon, the phase when the moon is hidden from view, aligns her with the deepest recesses of the unconscious. This is the realm where the unseen forces of the psyche reside, where the collective unconscious—the source of all archetypes and universal
                                                symbols—dwells. Just as the new moon is a time of introspection and hidden power, Hecate
                                                embodies the mysteries of the unknown, the primordial darkness from which all light emerges. In her darkness, the stars become more visible, representing the eternal archetypes and the infinite
                                                potential of the Cosmos. They are the guiding lights within the unconscious, illuminating the path for those who dare to explore the depths of their own souls".</span></p>

                                        <h3>Resonate Divine Name (1 to 3 times)</h3>
                                        <h5>Hecate - Heeeeeeecccccaaaaattttteeeeee</h5>


                                        <p>

                                            Draw to your conscious awareness the fertile infinite perimeter of Kali deep in the unconscious drawing in to surround you at every point.  While resonating Hecate bring to awareness the plurality of form that draws from deep within the void of Kali, the impulse to draw from the unconscious, the gateway to direct experience, is Hecate, the feminine womb teeming with the orgastic
                                            transconscious energy of vibratory power, ready to give birth.

                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block3_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block4------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block4_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>Helios</h3>
                                        <h5>Self Identification with the Objective Body of Light</h5>

                                        <p>
                                            At this point we have aligned with the Cosmos and invoked the astral plane, the Animu Mundi, the transitional realm between that which is unconscious to that which becomes luminous and manifest within the ritual. Throughout the ritual one has continuously drawn down the light from above the head and then increased its luminosity radiating out from the center of being. Now the invocation of Helios is a self identification directly with the luminous body of light itself.
                                        </p>
                                        <p>
                                            Helios is the sun, and we are also the sun. At this point in the ritual you have one specific identification that overtakes all others. You are to enter into the <span>“seed of the sun”</span> through identifying directly with the objective body of light.  The identification with Helios is a direct identification with the solar center of our solar system. Helios to the Greeks was the all-seeing witness: As the Sun, Helios was believed to observe and hear everything that occurred on Earth, as Krishna is the Omnipresent observer, Helios is the light of consciousness of the theurgist who can see deep into the past, clarify the present and see into the future through the identification with light itself, which does not experience time, thereby stepping the theurgist into the timeless realm of Aion <span>(see Central Docrine)</span>.
                                        </p>
                                        <p>From our Central Doctrine: <span>“You are emitting light that is tied to the very record of your human design, your DNA. This light maintains a continual record of everything happening in the cell which then broadcasts to all the other billions upon billions of photons you continue to emit from the over thirty trillion cells you have in your body.”</span></p>
                                        <p>Helios symbolizes the theurgist’s profound connection with the Solar Logos, representing an intrinsic identification with the inner body of light. This body of light originates from the biophotonic emissions of every DNA nucleus—a concept thoroughly explored in our Central Doctrine. To engage with this light body, employ the element of fire imaginatively to enhance your awareness and resonance with it. </p>

                                        <h3>Resonate Divine Name (1 to 3 times)</h3>
                                        <h5>Helios - Heeeellliiiioooooossssssss</h5>


                                        <p>
                                            As you resonate the Divine Name Helios you want to enter into the body of light and merge your
                                            consciousness with the objective solar nature of the self. This is a direct identification with the Solar Logos, the biophotonic emission from every DNA nucleus. Here the theurgist becomes the body of light and experiences <span>“from it.”</span> You are the solar seed at the center of the being.

                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block4_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block5------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block5_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>Protogonos</h3>
                                        <h5>Self Identification with the HGA, Personal Daemon, the Androgynous Protogonos</h5>

                                        <p>
                                            In the Orphic tradition, Protogonos, also known as Phanes, emerges from the Orphic Egg as the first being. Phanes is androgynous, signifying the origin of light and embodying the solar aspects of the <span>"prōtos ochēma psukhēs"</span>—the <span>"soul's first vehicle."</span> This <span>"ochēma"</span> represents a spherical
                                            self-boundary that mirrors the Cosmic Horizon in its entirety. It’s a personal sphere reflecting the
                                            universe, encapsulating the theurgist.
                                        </p>
                                        <p>The theurgist invokes Phanes by simultaneously embodying Helios, the solar seed or body of light, and Protogonos, the immortal surrounding spherical egg—the light-bringer. This combined invocation accesses the eternal divine double, the personal daemon, the infinite self interwoven with the Cosmic Horizon and the personal ōchēma, within an immortal realm outside space and time. Here, the timeless identification with Helios, the body of light, is fused into a single composite with Protogonos. Phanes, the androgynous god of the total objective self, unites the center of being with the spherical ōchēma. Through being Helios and becoming Protogonos, the theurgist initiates a ritual praxis of divine light.</p>

                                        <p>During this invocation, Protogonos—the androgynous first-born—manifests in a dual polarity. The male aspect represents the highest point of conscious awareness, identified with Helios, the radiant body of light. The feminine aspect is the immortal divine double: the encompassing astral sphere whose perimeter reflects the Cosmic Horizon—an infinitely hot boundary where matter exists as pure information, the generative source of all three-dimensional existence. This feminine sphere surrounds the theurgist as the solar astral egg, holding within it the unconscious and collective unconscious <span>“Objective”</span> unbounded Self <span>(see Central Doctrine)</span>. In this union, the center of awareness <span>(male)</span> and the infinite perimeter <span>(female)</span> interpenetrate, enacting the full mystery of Protogonos as both light and horizon, known and unknown, in a single theurgic act.</p>

                                        {/* <p>
                                            By maintaining this form within the astral body, the theurgist draws upon the Cosmic Horizon to
                                            integrate the awareness of their eternal, infinite divine self. This integration involves a spherical
                                            descent of divine essence from all directions towards the theurgist. This experience, as detailed in our Central Doctrine, is described as tangible and objective. In this state, the theurgist embodies the light body and the Solar Logos, merging with their daimōnic nature, which is both eternal and infinite. This divine double is not merely a part of the theurgist—it is the theurgist, experienced through the body of light. These aspects are objective and unified.

                                        </p> */}
                                        {/* <p>
                                            During this invocation, the male aspect represents the highest point of awareness, contained within the body of light. The feminine aspect is the spherical, immortal seed of Protogonos, the solar astral sphere surrounding the theurgist. This sphere encompasses the unconscious and collective
                                            unconscious, representing the infinite and immortal self.</p>
                                        <p>
                                            By maintaining this form within the astral body, the theurgist draws upon the Cosmic Horizon to
                                            integrate the awareness of their eternal, infinite divine self. This integration involves a spherical
                                            descent of divine essence from all directions towards the theurgist. This experience, as detailed in our Central Doctrine, is described as tangible and objective. In this state, the theurgist embodies the light body and the Solar Logos, merging with their daimōnic nature, which is both eternal and infinite. This divine double is not merely a part of the theurgist—it is the theurgist, experienced through the body of light. These aspects are objective and unified.</p> */}


                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block5_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block6------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block6_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>Resonate Divine Name (1 to 3 times)</h3>
                                        <h5 style={{ wordBreak: "break-all" }}>Protogonos - Prooooootoooooogooooonoooossss</h5>

                                        <p>
                                            When you invoke Protogonos, visualize your body of light—your conscious awareness—expanding and ascending. Simultaneously, feel your divine double, your personal daemon, your infinite eternal self,
                                            descending from every point of your spherical boundary.

                                        </p>
                                        <p>
                                            As Protogonos, your core essence—the Observer, the unwavering awareness within the boundless
                                            singularity, the male aspect—merges with the descending feminine spherical ochēma. This ochēma represents the unconscious, encompassing the collective unconscious, and all past, present and future of the total objective psyche and objective infinite self <span>(see Central Doctrine)</span>. This merging occurs both as a tangible, ecstatic physical union and a trans-conscious psychodynamic embrace. You are both the center and the encompassing sphere, you are Protogonos, the first born.
                                        </p>
                                        <p>
                                            In this state, you are prepared to encounter the realm of Divine Intelligences, the eternal archetypes and forms. You are ready to receive their divinatory and revelatory wisdom, their vast, perfecting agency of form.</p>



                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block6_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block7------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block7_mainWrp}`} ref={aligningTheElementsRef}>

                        <div className={styles.common_width}>
                            <div className={styles.column} ref={aligningTheElementsRef}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Aligning the elements with the Dēmiurgós - Casting the Pentagrams
                                    </h2>
                                </div>
                            </div>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <p>Having completed the Grand Invocation, you are now prepared to channel the infinite Divine Nature to manifest the will of the Dēmiurgós, the creator of the Universe, into a purified extension across the four cardinal directions of your ritual space. While traditional Pentagram rituals often begin facing east, aligning with the element of air, our approach allows for flexibility. East is still suggested if
                                            feasible, but in this specific ritual, you will begin facing the direction of fire.


                                        </p>


                                        <p>
                                            At this point, the theurgist performs banishments and purifications, or invocations, of the four
                                            elements in their raw, primal forms. These represent the Aces in the Tarot, the initial surge of
                                            elemental power. This aligns the four elements with the Dēmiurgós, establishing harmony and unity. Using your dagger or sword for banishing and your wand for invoking, you will draw four Pentagrams: one directly in front of you, one directly behind you, one to your left, and one to your right.

                                        </p>



                                        <p>
                                            As you draw each Pentagram, face the corresponding direction and resonate the appropriate Divine name. You should draw the Pentagram starting with the first sound of your voice and be done just as you are finishing the resonation.
                                        </p>
                                        <p>Then, point your ritual instrument at the center of the Pentagram. As you inhale, draw the elemental power into the core of your being. As you exhale, empower the Pentagram symbol with the full energy of your instrument. Take another deep breath, and then turn clockwise to the next Pentagram. In front of you is fire, to the right is water, behind you is air, to your left is earth. The purpose of this
                                            designation is significant in our version of the ritual. Starting with fire you are drawing heaven to earth, which moves to water, then air, then earth is a circular fashion in the ritual embracing the
                                            spherical theurgic work of manifestation of light to that of matter.</p>

                                        <p>When invoking, move your instrument towards the element; when banishing, move it away. If you are performing an invocation of the elements you want to first banish every time.  Once you have
                                            performed the banishing the elements are purified and prepared for invocation.  Directly after the
                                            banishing hold the sign of silence for three full breaths and then perform the invocations.
                                        </p>

                                        <p>Ensure your Pentagrams are consistently drawn, roughly half your height, with their top points
                                            slightly above your head. Visualize the Pentagrams being drawn with the energy that you have
                                            built up during the initial Grand Invocation. </p>

                                        <p>As you draw each Pentagram, you are projecting the Divine Will to its first point and then to each of the other points drawing the symbol. For the proper effect within your imaginal being experience coming from the opposite direction of your drawing a counterforce emanating from an infinite source, drawing the Pentagram with you. The tension between these two forces the theurgist and the eternal, infinite being—imbues the Pentagrams with immense energy.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block7_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block8------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block8_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <h5><span>Element of fire,</span></h5>

                                        <p>
                                            <span>(Banishing)</span> Pronounce: <span>“Element of fire, I purify and set you in service of the Creator of the Universe”</span>


                                        </p>
                                        <p>

                                            <span>(Invoke)</span> Pronounce: <span>“Element of fire, thee I invoke, and set you in service of the Creator of the Universe”</span>

                                        </p>
                                        <br />
                                        <p>
                                            <span>Pyros Demiurgos: Pyyyyyroooossss Deeeeemiiiiiurrrrrgoooossssss</span>
                                        </p>



                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/element_of_fire_img_new_19Aug.webp"
                                        alt='Image'
                                    />
                                    <img
                                        className={styles.abs_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/element_of_fire_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block9------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block9_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <h5><span>Element of water,</span></h5>

                                        <p>
                                            <span>(Banishing)</span> Pronounce: <span>“Element of water, I purify and set you in service of the Creator of the Universe”</span>



                                        </p>
                                        <p>

                                            <span>(Invoke)</span> Pronounce: <span>“Element of water, thee I invoke, and set you in service of the Creator of the Universe”</span>

                                        </p>
                                        <br />
                                        <p>
                                            <span>Húdōr Demiurgos: Huuuuudooooorrrr Deeeeemiiiiiurrrrrgoooossssss</span>
                                        </p>



                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/element_of_water_img_new_19Aug.webp"
                                        alt='Image'
                                    />
                                    <img
                                        className={styles.abs_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/element_of_water_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block10------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block10_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <h5><span>Element of air,</span></h5>

                                        <p>
                                            <span>(Banishing)</span> Pronounce: <span>“Element of air, I purify and set you in service of the Creator of the Universe”</span>



                                        </p>
                                        <p>

                                            <span>(Invoke)</span> Pronounce: <span>“Element of air, thee I invoke, and set you in service of the Creator of the Universe”</span>

                                        </p>
                                        <br />
                                        <p>
                                            <span>Aer Demiurgos: aaaaaeeeeeeerrrrrrrr Deeeeemiiiiiurrrrrgoooossssss</span>
                                        </p>



                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/element_of_air_img_new_19Aug.webp"
                                        alt='Image'
                                    />
                                    <img
                                        className={styles.abs_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/element_of_air_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block11------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block11_mainWrp}`}>
                        <div className={styles.common_width}>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <h5><span>Element of earth,</span></h5>

                                        <p>
                                            <span>(Banishing)</span> Pronounce: <span>“Element of earth, I purify and set you in service of the Creator of the Universe”</span>




                                        </p>
                                        <p>

                                            <span>(Invoke)</span> Pronounce: <span>“Element of earth, thee I invoke, and set you in service of the Creator of the Universe”</span>

                                        </p>
                                        <br />
                                        <p>
                                            <span>Gaea Demiurgos: gaaaaaeeeeeeeeaaa Deeeeemiiiiiurrrrrgoooossssss</span>
                                        </p>



                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/element_of_earth_img_new_19Aug_nn.webp"
                                        alt='Image'
                                    />
                                    <img
                                        className={styles.abs_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/element_of_earth_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block12------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block12_mainWrp}`} >

                        <div className={styles.common_width}>
                            <div className={styles.column} ref={invocationOfTheRef}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Invocation of the guardian daemons
                                    </h2>
                                </div>
                            </div>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>






                                        <p>Each of the four cardinal guardian daemons stands at their appointed station in the four directions, forming a living perimeter around the theurgist. They do not remain merely as guardians at a distance—they unite directly with the theurgist’s own persona, infusing the practitioner’s field with their immense protective force. Drawn from the four cardinal signs of the Zodiac—Aries, Cancer, Libra, and Capricorn—these beings confer their cardinal virtues: the initiating power of fire, the nurturing stability of water, the harmonizing balance of air, and the enduring order of earth. In the Tarot, they are represented by the Twos of the suit cards, each card expressing the perfected inception of its element through planetary influence and daemonic embodiment.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_mainWrp_bg.webp"
                                        alt='Image'
                                    />

                                    <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />

                                    <img
                                        className={`${styles.school_ritual_img1_abs}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/psd_3_block_12_color_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>

                            <div className={styles.school_ritual_psd3_block12_section_flx_wrp}>
                                <div className={styles.school_ritual_psd3_block12_section_flx_mini}>
                                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_section_flx_mini_fire.webp' alt='Image' />
                                    {/* <h4>Fire (Tarot - Dominion) - Mars in Aries</h4> */}
                                    <h4>Aries / 2 of Wands, Dominion:</h4>
                                    <p>Mars in Aries, the fierce guardian <span>Kratos</span>, daemonic spirit of strength and dominion. Here, fire’s initiating impulse is pure, direct, and sovereign—granting the will to command and the courage to act without hesitation.</p>
                                    <p>Pronounce: <span>"Kratos, the Dominion of spirit, then I invoke"</span></p>
                                    <p><span>Kratos: krrrraaaaatooooosssssss</span></p>
                                </div>

                                <div className={styles.school_ritual_psd3_block12_section_flx_mini}>
                                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_section_flx_mini_water.webp' alt='Image' />
                                    {/* <h4>Water (Tarot Love) - Venus in Cancer</h4> */}
                                    <h4>Cancer / 2 of Cups, Love: </h4>
                                    <p>Venus in Cancer, the tender guardian <span>Eros</span>, daemonic spirit of love and unifying desire. Water’s cardinal current is here a bond of deep affection, mutuality, and the capacity to nurture bonds that endure through time.</p>
                                    <p>Pronounce: <span>"Eros, The Essence of divine love, thee I invoke"</span></p>
                                    <p><span>Eros: eeeeeerrrrrrooooosssss</span></p>

                                </div>

                                <div className={styles.school_ritual_psd3_block12_section_flx_mini}>
                                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_section_flx_mini_air.webp' alt='Image' />
                                    {/* <h4>Air (Tarot - Peace) - Moon in Libra</h4> */}
                                    <h4>Libra / 2 of Swords, Peace:</h4>
                                    <p>Moon in Libra, the serene guardian <span>Eirene</span>, daemonic spirit of peace and equilibrium. Air’s cardinal quality manifests as calm discernment, the balancing of opposites, and the clarity to judge without bias.</p>
                                    <p>Pronounce: <span>"Eirene - the Purely reflected balance, thee I invoke"</span></p>
                                    <p><span>Eirene: eeeeiiiirrrrreeeeennnnn</span></p>

                                </div>

                                <div className={styles.school_ritual_psd3_block12_section_flx_mini}>
                                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block12_section_flx_mini_earth.webp' alt='Image' />
                                    {/* <h4>Earth (Tarot Change) - Jupiter in Capricorn</h4> */}
                                    <h4>Capricorn / 2 of Disks, Change:</h4>
                                    <p>Jupiter in Capricorn, the wise guardian <span>Janus</span>, daemonic spirit of transition and mastery of thresholds. Earth’s cardinal force here expresses the stability that transforms, the measured shift that sustains order while opening new possibilities.</p>
                                    <p>Pronounce: <span>"Janus - the Stability in changing form, then I invoke"</span></p>
                                    <p><span>Janus: jaaaaaannnnuuuussss</span></p>

                                </div>
                            </div>

                            <div className={styles.school_ritual_psd3_block12_section_new_txt}>
                            <p>These four are the divine presences of the highest daemonic nature—helping spirits, protectors, and allies in the core activities of life. While many traditions place the four Archangels—Michael, Gabriel, Uriel, and Raphae, which is totally appropriate—in these stations, the Greek daemonic forms remain most closely aligned with our School’s theurgical current. Regardless of the chosen form, these beings are to be understood as real, vast intelligences—spirits whose agency binds the theurgist to the Divine Path, guiding, directing, and protecting at every step.</p>
                            <p>They embody the elemental powers from which they arise, yet take relational form, both accessible to the conscious mind and rooted in the deep archetypal strata of the soul. They serve simultaneously the Dēmiurgós and the theurgist, creating a living bond between the two. In this way, the four stations do more than guard—they form an interlocked field of power, virtue, and agency, aligning the practitioner with the cardinal cross of the heavens and the elemental order of the cosmos.</p>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block13------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block13_mainWrp}`} >

                        <div className={styles.common_width}>
                            <div className={styles.column} ref={finalPronouncementRef}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Final pronouncement - closing of the Ritual
                                    </h2>
                                </div>
                            </div>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>






                                        <p>If you are only performing the Banishing ritual of the Pentagram then you would move to the final pronouncement right after the calling of the guardians. If you are working with any of the more extensive Pentagram ritual sets then you would hold this final pronouncement until the entire ritual set is completed. So this follows all of the ritual praxis work as the final in any case.</p>
                                        <p>Final Pronouncement: <span>"For I am the four elements crowned by a fifth, the spirit, the Aether, the infinite eternal self. I align myself, and the forces of my inner nature, with the Cosmos, the eternal being, for I am one, our  Divine Infinite Being".</span>
                                        </p>
                                        <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                        <p style={{ wordBreak: "break-all" }}><span>Ehye: eeeeeeeehhhhheeeeyyyyyyyyaaaaaaaa</span></p>
                                        <p>
                                           This final, closing Resonate Divine Name — <span>'Ehye 'ăšer 'Ehye</span> — is the same utterance that opened the rite, the Alpha and Omega of the working. It is the Name of pure self-identity in the state of ecstatic non-duality, the eternal <span>“I Am That I Am”</span> which has silently undergirded the entire ritual arc from its inception. Spoken here at the conclusion, it serves as the great re-collection: drawing every force, every image, every invoked presence back into the indivisible simplicity of the One.</p>

                                           <p>As the Name vibrates into stillness, hold the Sign of Silence for no fewer than three full breaths, remaining longer if intuition bids. In this interval, the theurgist rests at the unbroken point between self and our Divine Infinite Being — the place where all distinctions dissolve and all the energies awakened in the rite are absorbed back into their primordial unity.</p>

                                           <p>Here, the diverse agencies summoned in the Grand Invocation are not dismissed but sublimated — the planetary gods, the zodiacal powers, the cardinal daemons, and every other divine intelligence invoked are drawn back into the singular awareness from which they first emerged. This is the consummation of the work: the return to the undivided radiance that transcends both within and without, permeating all without boundary.</p>
                                           <p>Remain in this stillness until the full resonance of the rite is felt as complete within your being. Let the departure unfold of its own accord — without haste, without fracture — only the unbroken continuity of the One.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block13_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </LazySection>


                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block13_mainWrp_1}`}>
                        <div className={styles.common_width}>
                          
                                  <div className={styles.column} ref={invocationOfDivineInfiniteBeing}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        INVOCATION OF OUR DIVINE INFINITE BEING
                                    </h2>
                                </div>
                            </div>
                            <div className={`${styles.school_ritual_psd3_block13_mainWrp_1_sub}`} >

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    {/* <h3>INVOCATION OF OUR DIVINE INFINITE BEING</h3> */}

                                    <p>This invocation is the standard invocation as we have explained above.  If performing an invocation Pentagram Ritual beyond the <br />standard Banishing, we suggest including the invocation of our Divine Infinite Being as part of your practice.
                                    </p>

                                    <p>I am one. Our Divine Infinite Being</p>

                                    <p>Identical as Self and separated as Divine throughout the Cosmos.</p>

                                    <p>I pray, meditate, philosophize, and engage the Theurgic ceremony of union</p>

                                    <p>Father Source Singularity, Center of Gravity, Center of Consciousness, Eternal and Infinite <br></br>
                                        THEE I INVOKE</p>
                                    <p>Mother Source Spherical Horizon, Collective Unconscious, Womb of the Cosmos <br></br>THEE I INVOKE</p>
                                    <p>Immortal Parents sprung from one single unifying source</p>
                                    <p>At once, entangled, present in the child, the Theurgist <br></br> I AM THAT</p>

                                    <p>Consciousness peering into the vastness awake and alive <br></br>
                                        I AM THAT</p>

                                    <p>The collective infinite possibility surrounding me, rooted in the eternal spherical boundless one <br></br>
                                        I AM THAT</p>

                                    <p>My own boundary, spherical star vehicle, ceremonial lens reflecting the perfecting nature of one <br></br>
                                        I AM THAT</p>

                                    <p>The greatest boundary, unified whole Spacetime Geometry, absolutely coherent, perfect, <br />eternal,<br /> whose grand history I enter into my future <br></br> THEE I INVOKE</p>

                                    <p>Obscured within me and surrounding me that I may make disciplined effort
                                        <br></br> THE GREAT WORK </p>

                                    <p>Through vigilance I awaken to the eternal divine presence in every experience <br></br>  I AM ONE </p>

                                    <p>Separated for chance of Union I worship you with endless devotion</p>

                                    <p>Thou art my lover, my father, my mother, myself</p>

                                    <p>I am one. Our Divine Infinite Being</p>


                                </div>

                            </div>
                        </div>

                    </div>
                </LazySection>

                {/* ---------------------------block14------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block14_mainWrp}`} >

                        <div className={styles.common_width}>
                            <div className={styles.column} ref={hermesApolloRef}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        INVOCATION of Hermes-Apollo
                                    </h2>
                                </div>
                            </div>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <h3>Preparation for theurgic union, divination and prophetic knowledge</h3>




                                        <p>When working beyond the Banishing and Invoking forms, and past the central Divine Infinite Being Pentagram Ritual, the theurgist enters the preparation for possession by a specific planetary god, zodiacal force, or their synthesis. Here, the soul is offered wholly — the body of light and ōchema sacrificed — to receive the descent of the great syncretized god of divination and prophecy, Hermes-Apollo.

                                        </p>
                                        <p>From the solar seed of Helios, the theurgist shifts into the full, sovereign personality of the Sun as Apollo. At the same time, the outermost perimeter becomes alive with Hermes at every point — the swift and subtle messenger encircling the rite. In their union, Hermes–Apollo stands as the axis between worlds, guiding the theurgist deeper into the boundless sphere of Aion, becoming his eyes, ears and engulfing his persona in their timeless knowledge and activity.</p>

                                        <p>
                                            Hermes embodies communication, the movement between realms, and the transmission of divine wisdom. He descends from all points surrounding the theurgist, symbolizing his capacity to traverse all boundaries and mediate between the known and the unknown, the seen and the unseen. In this role, Hermes acts as a guide and protector, ensuring that the sacred messages from the divine are accurately delivered and understood. His presence in the invocation facilitates a multi-directional flow of divine knowledge, gathering the scattered truths from the periphery and bringing them into the
                                            consciousness of the theurgist.
                                        </p>

                                        <p>Apollo, on the other hand, represents the solar center—both literally as a sun god and through his vast agency as a beacon of clarity and prophecy. His domain over music, poetry, and the arts, often referred to as the <span>"music of the spheres,"</span> resonates with the harmonious order of the cosmos bonding the macrocosmic solar system and the personal microcosm of the theurgist. By invoking Apollo, the theurgist taps into the rhythmic and harmonic nature of the universe, aligning themselves with the celestial patterns that govern existence. Apollo's solar aspect illuminates the mind of the theurgist, burning away confusion and doubt, and enabling a clear channel for prophecy and visionary insights.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block14_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block15------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block15_mainWrp}`}>

                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>






                                        <p>The combination of Hermes and Apollo in a single invocation creates a dynamic interplay of energies: Hermes facilitates the descent of knowledge through his agility and mastery over
                                            transitions, while Apollo centralizes and clarifies these insights through his luminous and ordering nature. This syncretization brings together the periphery and the core, the multitude of divine whispers and the singular voice of prophetic truth.

                                        </p>

                                        <p>
                                            Experientially, this invocation feels like a dance of celestial forces, where Hermes' swift, mercurial energy circles and weaves around Apollo's steady, radiant core. The theurgist, standing at the nexus of this sacred interplay, experiences a convergence of wisdom and clarity. As Hermes delivers the divine messages and Apollo interprets and ennobles them, the theurgist becomes a vessel of heavenly truth, capable of understanding and communicating the divine will with profound clarity.
                                        </p>

                                        <p>
                                            Thus, the invocation of Hermes and Apollo is not merely a ritualistic call but an experiential journey into the depths of divine wisdom, guided by the dual forces of movement and stability, periphery and center, transmission and reception. This powerful synthesis enables the theurgist to receive, comprehend, and disseminate the divine prophecies that are crucial continued invocation of the planetary and zodiacal forces.  It is through the invoked possession of Hermes-Apollo where the limited expressions of the Divine Intelligences appear in their unlimited infinite forms thereby transforming the theurgist through the presence of their vast agency.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block15_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block16------------------- */}
                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd3_block16_mainWrp}`}>

                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>






                                        <p>Resonate Divine Name <span>(1 to 3 times)</span>


                                        </p>

                                        <p style={{ wordBreak: "break-all" }}>
                                            <span >Hermes-Apollo: HeeerrrmmmeeesssApoooolllooooooo</span>
                                        </p>

                                        <p>

                                            While resonating the Divine Name feel your magical personality, the body of light, the Genius of Helios, merging with the Divine eternal and infinite personality of Apollo, the intelligence and centrality of the solar center. At the same time experience from all points of the spherical perimeter, interwoven with the ochēma, the self boundary, Hermes descending from every point merging with Apollo opening the gates of divinatory and revelatory power in their merging at the point of self awareness.

                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd3_block16_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </LazySection>
            </div>




        </>
    )
}

export default SchoolRitualBlockThree
